import { Box } from '@alf/uikit';

import styles from './index.module.css';

export const Fixer = ({ children }) => (
  <Box align="center" justify="center" className={styles.root}>
    {children}
  </Box>
);
